import styled, { css } from 'styled-components'
import * as ds from '@bob/design-system'

export const BrushPinkBackground = ds.utils.svg.toDataUrl(ds.brush.full.FullBrush5, {
  width: 482,
  height: 91,
  fill: ds.color.PINK,
})

export const BrushGreenBackground = ds.utils.svg.toDataUrl(ds.brush.full.FullBrush2, {
  width: 482,
  height: 91,
  fill: ds.color.LIGHT_GREEN,
})

export const BrushYellowBackground = ds.utils.svg.toDataUrl(ds.brush.full.FullBrush4, {
  width: 482,
  height: 91,
  fill: ds.color.YELLOW,
})

export const Brush = styled.span<{ brushId?: string; inView?: boolean; delay?: number }>`
  display: inline-block;
  position: relative;
  z-index: -1;

  @keyframes brush-slide {
    from {
      clip-path: inset(0 100% 0 0);
    }
    to {
      clip-path: inset(0 0 0 0);
    }
  }

  &::before {
    position: absolute;
    content: '';
    display: block;
    top: -0.5em;
    left: -1em;
    bottom: -0.5em;
    right: -0.75em;
  }

  &::before {
    z-index: -2;
    background-image: ${({ brushId }) =>
      brushId === 'pink'
        ? `url('${BrushPinkBackground}')`
        : brushId === 'green'
        ? `url('${BrushGreenBackground}')`
        : `url('${BrushYellowBackground}')`};
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;

    animation: brush-slide 0.4s ease-in-out both;
    animation-play-state: paused;
    animation-delay: ${({ delay = 0 }) => `calc(0.1s * var(--word-index, 0) + 0.2s + ${delay}s)`};

    ${({ inView }) =>
      inView &&
      css`
        animation-play-state: running;
      `}
  }
`
